<template>
  <div id="app" class="h-100 pagebg">
    <!-- 加载动画 -->
    <div class="loads" v-show="isload">
      <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
    </div>
    <div class="inspectCategory">
      <el-dropdown @command="selectCheckCategory" trigger="click" style="display: block;">
        <span style="font-size:0.2rem; color: white;  line-height: 0.3rem;" class="el-dropdown-link">
          检验分类：{{ queryParams['checkCategory']["uuid"] ? queryParams['checkCategory']["title"] : "所有分类"
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="''">所有分类</el-dropdown-item>
          <el-dropdown-item :command="item" v-for="(item, i) in checkCategoryList" :key="i">{{ item.title
            }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="selectProductLine" trigger="click">
        <span style="font-size:0.2rem;color: white;  line-height: 0.3rem;" class="el-dropdown-link">
          产线：{{ queryParams['product']["uuid"] ? queryParams['product']["title"] : "所有产线"
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="''">所有产线</el-dropdown-item>
          <el-dropdown-item :command="item" v-for="(item, i) in productList" :key="i">{{ item.title
            }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="time">{{ now }} {{ week }}<br />
      <span>更新时间：{{ updateTimeText }}</span>
    </div>
    <div @click="signOut" class="power">
      <i style="cursor: pointer" class="el-icon-back"></i>
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />
      <div class="font-big1 font-weight">
        {{ title ? title : "不良品看板" }}
      </div>
    </header>
    <div class="flex h-90 flex-wrap">
      <div class="p2 w-50 h-50 flex">
        <!--合格率-->
        <pass-rate :beans="passRate"></pass-rate>
      </div>
      <div class="p2 w-50 h-50 flex">
        <!--缺陷柏拉图-->
        <defect-plato :beans="platoList"></defect-plato>
      </div>
      <div class="p2 w-50 h-50 flex">
        <!--缺陷列表-->
        <defect-list :beans="issueList"></defect-list>
      </div>
      <div class="p2 w-50 h-50 flex">
        <!--缺陷图片-->
        <defect-img-list :beans="imgList"></defect-img-list>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../../router";
import format from "date-fns/format";
import DefectImgList from "../component/defect-img-list";
import DefectList from "../component/defect-list";
import DefectPlato from "../component/defect-plato";
import PassRate from "../component/pass-rate";
export default {
  name: "App",
  data() {
    return {
      height: 600,
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      isload: false,
      passRate: [], //合格率
      platoList: null, //缺陷柏拉图
      imgList: [], //图片列表,
      issueList: [], //缺陷列表
      typeTotal: [],
      now: null,
      week: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "Nok KanBan",
      updateTimeText: null,
      productList: [],
      checkCategoryList: [],
      queryParams: {
        product: {},
        productUUID: '',
        checkCategory: {},
        checkCategoryUUID: ''
      },
    };
  },
  components: {
    DefectImgList,
    DefectList,
    DefectPlato,
    PassRate,
  },
  mounted() {
    this.webSocket();
    this.loadData();
    this.loadBoardTitle();
    this.loadProductLine();
    this.loadNokCheckCategory();
    //钟表
    setInterval(this.clock, 1000);

    let that = this;
    var height = document.documentElement.clientHeight;
    that.height = height - height * 0.11;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        that.height = window.fullHeight - window.fullHeight * 0.11; // 实时高
      })();
    };

  },
  created() {
    this.isload = true;
    if (this.$route.query.productUUID) {
      this.queryParams['productUUID'] = this.$route.query.productUUID;
    }
    if (this.$route.query.checkCategoryUUID) {
      this.queryParams['checkCategoryUUID'] = this.$route.query.checkCategoryUUID;
    }
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    signOut() {
      router.back();
    },
    selectProductLine(item) {
      this.queryParams.product = item || {};
      this.queryParams.productUUID = item ? item.uuid : null;
      this.loadData();
    },
    selectCheckCategory(item) {
      this.queryParams.checkCategory = item || {};
      this.queryParams.checkCategoryUUID = item ? item.uuid : null;
      this.loadData();
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
              var map = {};
              this.productList.forEach(item => {
                map[item['uuid']] = item;
              })
              this.queryParams['product'] = map[this.queryParams['productUUID']] || {};
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadNokCheckCategory() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.nokCheckCategory()
          .then((res) => {
            if (res.success === true) {
              this.checkCategoryList = res["list"];
              var map = {};
              this.checkCategoryList.forEach(item => {
                map[item['uuid']] = item;
              })
              this.queryParams['checkCategory'] = map[this.queryParams['checkCategoryUUID']] || {};
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });

      var params = { query: { name: "nok" } };
      API.loadBoardTitle(params).then((re) => {
        if (re.success && re["list"].length > 0) {
          this.title = re["list"][0]["boardName"];
        }
      });
    },

    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var params = { productLineUUID: this.queryParams['productUUID'], 'checkUUID': this.queryParams['checkCategoryUUID'] };
        this.isload = true;
        API.nokData(params)
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.passRate = res["dayPassRateList"];
              this.platoList = res["platoList"];
              this.imgList = res["imgList"];
              this.issueList = res["defectDetails"];
              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/nok/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/nok/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("Nok socket连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("Nok socket连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("Nok socket断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>

<style>
.pagebg {
  background: url("../../../assets/img/bg2.png");
}

.p2 {
  padding: 0.05rem 0.05rem;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 50px;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}

.color-gray {
  color: #cdeaf6;
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}

.inspectCategory {
  color: white;
  position: absolute;
  right: 25%;
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/pages/nok/board/board.vue